import React from "react";
import { ListGroup } from "react-bootstrap";

/**
 * SelectedAnlagenList
 * 
 * used in LeerstandPage
 * 
 * @param {top} props object Top
 * @param {selectedAnlagen} props object Anlage
 * @param {anlagen} props arraj of Anlagen objects
 * @returns 
 */
const SelectedAnlagenList = (props) => {

    const top = props.top;
    const selected = props.selectedAnlagen;
    const avaible = props.anlagen;

    return (
        <ListGroup className="text-center" variant="flush">
            {avaible.filter(av => selected.includes(av.id)).map(sel => (
                <ListGroup.Item key={sel.id}>
                    Anlage ({sel.x_studio_field_mWMGR}): Leerstand wird&nbsp;
                    {sel.x_studio_field_Xhbek[0] === top.x_gebaeude_id[0]? "abgemeldet":"angemeldet"}
                </ListGroup.Item>
            ))}
        </ListGroup>
    )
}
export default SelectedAnlagenList;